import {systemMessage} from "@/data-services/store/system-message";

function initStore(store) {
  const state = {
    namespaced: true,
    state: {
      notification: {
        msgs: [],
        unRead: 0,
      }
    },
    mutations: {
      ['READ_NOTIFICATION'](state) {
        state.notification.unRead = 0
      },
      ['NOTIFICATION_ADD_COUNT'](state, data) {
        state.notification.unRead += data
      },
      ['NOTIFICATION_DISPATCH'](state, data) {
        state.notification.msgs = [...state.notification.msgs, ...data]
      }
    },
    actions: {
      systemMessage,
      readNotification({commit}) {
        commit('READ_NOTIFICATION')
      }
    }
  }
  store.registerModule(["dataCenter"], state);
}


export default {
  initStore
}
